// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QmL8","question":"styles_question__2hoew","inputVisibleButton":"styles_inputVisibleButton__2f3LL","note":"styles_note__2IrVQ"};